<template>
  <div class="page-head">
    <h1>{{ t("Projets", "Projects") }}</h1>
    <p class="lead">{{ t("Une sélection de projets sur lesquels j'ai travaillé.", "A selection of projects I've worked on.") }}</p>
  </div>

  <section class="sec">
    <div class="sec-head">
      <h2><Folder />{{ t("Projets", "Projects") }}</h2>
    </div>
    <div class="cards">
      <component
        :is="p.url ? 'a' : 'div'"
        v-for="p in projects"
        :id="p.slug"
        :key="p.slug"
        class="pcard"
        :href="p.url || undefined"
        :target="p.url ? '_blank' : undefined"
        :rel="p.url ? 'noopener' : undefined"
      >
        <span :class="['img', { contain: p.contain }]"><img :src="p.image" :alt="`${t('Aperçu de', 'Preview of')} ${p.name}`" loading="lazy" :style="p.imageStyle" /></span>
        <span class="body">
          <span class="top">
            <span class="id">
              <CompanyLogo :src="p.logo" :photo="p.photo" />
              <span><h3>{{ p.name }}</h3><span class="k">{{ t(p.kind) }}</span></span>
            </span>
            <span :class="['badge', p.badgeClass]">{{ t(p.badge) }}</span>
          </span>
          <p>{{ t(p.text) }}</p>
        </span>
      </component>
    </div>
  </section>

  <section class="sec">
    <div class="sec-head">
      <h2><Code />Open source</h2>
    </div>
    <ul class="plist">
      <li class="pitem">
        <CompanyLogo :src="rasengan.logo" />
        <div>
          <div class="t">
            <a :href="rasengan.url" target="_blank" rel="noopener">RasenganJS <ArrowUpRight class="inline" /></a>
          </div>
          <div class="k">{{ t("TypeScript · framework React", "TypeScript · React framework") }}</div>
        </div>
        <span class="badge">{{ t("Contributrice", "Contributor") }}</span>
        <p v-if="lang === 'fr'">
          Je contribue aux templates officiels de RasenganJS, publiés sur le hub du framework, et au
          <a class="inline-link" :href="rasengan.examples" target="_blank" rel="noopener">dépôt d'exemples</a>.
        </p>
        <p v-else>
          I contribute to the official RasenganJS templates, published on the framework's hub, and to the
          <a class="inline-link" :href="rasengan.examples" target="_blank" rel="noopener">examples repository</a>.
        </p>
      </li>
    </ul>
  </section>
</template>

<script>
import { ArrowUpRight, Code, Folder } from "lucide-vue-next";
import CompanyLogo from "@/components/Logo.vue";
import { PROJECTS, RASENGAN } from "@/content";
import { useI18n } from "@/i18n";

export default {
  name: "ProjectsPage",
  components: { ArrowUpRight, Code, Folder, CompanyLogo },
  setup: () => ({ ...useI18n(), projects: PROJECTS, rasengan: RASENGAN }),
};
</script>

<style scoped>
.id {
  display: flex;
  gap: 10px;
  align-items: center;
}
.plist {
  list-style: none;
}
.inline {
  width: 15px;
  height: 15px;
  vertical-align: -2px;
}
.inline-link {
  color: var(--ink);
  text-decoration: underline;
  text-decoration-color: var(--pink-bright);
  text-underline-offset: 3px;
}
</style>
